import React from 'react';
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Link,
} from '@mui/material';
import { config } from '../../config';

interface TermsAndConditionsCheckboxProps {
    acceptedTerms: boolean;
    setAcceptedTerms: (acceptedTerms: boolean) => void;
    showError?: boolean;
}

export const TermsAndConditionsCheckbox = (
    props: TermsAndConditionsCheckboxProps
) => {
    const { acceptedTerms, setAcceptedTerms, showError } = props;

    return (
        <FormControl error={showError}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    columnGap: 0.5,
                }}
            >
                <FormControlLabel
                    sx={{ m: 0 }}
                    control={
                        <Checkbox
                            checked={acceptedTerms}
                            value={acceptedTerms ? '1' : '0'}
                            onChange={(event) => {
                                setAcceptedTerms(event.target.checked);
                            }}
                        />
                    }
                    label="I agree to the Neon by Marex"
                />
                <Link
                    href={config.premiumContentPageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Terms of Service for Premium Content
                </Link>
            </Box>
            {showError ? (
                <FormHelperText>
                    Terms of Service for Premium Content is required
                </FormHelperText>
            ) : null}
        </FormControl>
    );
};

export default TermsAndConditionsCheckbox;
